var e;

function a(e) {
  return "AppCapabilities/1 (" + e.reduce(function (e, a) {
    return "" + e + a.capability + (a.enabled ? "1" : "0");
  }, "") + ")";
}

function i(a) {
  var i = null,
      n = /AppCapabilities\/1 \(([^)]*)\)/.exec(a);

  if (null != n && n[0]) {
    i = [];

    for (var t, l = n[1], r = /([a-zA-Z]+)(\d+)/g; t = r.exec(l);) {
      var u = t[1],
          p = t[2];
      Object.values(e).includes(u) && i.push({
        capability: u,
        enabled: Boolean(Number(p))
      });
    }
  }

  return i;
}

!function (e) {
  e.NativeUpload = "a", e.PostMessage = "b", e.NativeNavigation = "c", e.ApplePay = "d";
}(e || (e = {}));
export { e as Capability, i as parseCapabilities, a as serializeCapabilities };